// removed by extract-text-webpack-plugin
module.exports = {"photo":"photo_ydnxe","inner":"inner_3pMwY","action":"action_1NqHf","fill":"fill_1EeVv","image":"image_r8B1z","selection":"selection_39168","actions":"actions_2k3gV","pin":"pin_1XlxM","fav":"fav_2Fn2P","active":"active_1SaJl"};


//////////////////
// WEBPACK FOOTER
// ./app/components/assignment-photo/styles.scss
// module id = 410
// module chunks = 1